import React, { Fragment } from 'react';
import { string, object } from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

const InjectMassage = props => <FormattedMessage {...props} />;

const InjectSimpleText = ({ id, intl, values }) => (
  <Fragment>{intl.formatMessage({ id }, values || {})}</Fragment>
);

InjectSimpleText.propTypes = {
  id: string,
  values: object,
  intl: intlShape,
};

const SimpleText = injectIntl(InjectSimpleText);

export { SimpleText };

export default injectIntl(InjectMassage, {
  withRef: false,
});
